import React, { useEffect, useState } from 'react';
import { Form, DatePicker, Button, Row, Col, message, Select, Typography } from 'antd';
import axiosInstance from '../../services/axiosInstance';
import moment from 'moment';

const DownloadAnyFLSheet = ({ handleClose }) => {
    const [loading, setLoading] = useState({
        formSubmission: false,
        getDropdown: false
    });
    const [dropdownList, setDropDownList] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        setLoading(prev => ({
            ...prev,
            formSubmission: true
        }));
        try {
            const from_date = values.dates[0].format('YYYY-MM-DD');
            const to_date = values.dates[1].format('YYYY-MM-DD');

            const params = {
                from_date,
                to_date,
                email: selectedEmail,
            };

            const response = await axiosInstance.get('/task/v2/any-freelancer-sheet/', {
                params,
                responseType: 'blob'
            });

            if (response.status === 200) {
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${moment().format('DD-MM-YYYY hh:mm A')}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                message.success("Sheet Download Successfully");
                handleClose();
            } else {
                message.error("Something went wrong");
            }
        } catch (err) {
            if (
                err?.response?.data instanceof Blob &&
                err?.response?.headers['content-type']?.includes('application/json')
            ) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result);
                        const errorMsg = errorJson?.message || errorJson?.detail || 'Error downloading sheet';
                        message.error(errorMsg);
                    } catch (parseErr) {
                        message.error("Unknown error");
                    }
                };
                reader.readAsText(err.response.data);
            }
        } finally {
            setLoading(prev => ({
                ...prev,
                formSubmission: false
            }));
        }
    };

    const fetchDropdownList = async () => {
        setLoading(prev => ({
            ...prev,
            getDropdown: true
        }));
        try {
            const res = await axiosInstance.get("/task/v2/freelancer-dropdown/")

            if (res.status === 200) {
                setDropDownList(res.data.data || [])
                setLoading(prev => ({
                    ...prev,
                    getDropdown: false
                }));
            }

        } catch (err) {
            console.log(err)
            setLoading(prev => ({
                ...prev,
                getDropdown: false
            }));
        }
    }

    useEffect(() => {
        fetchDropdownList()
    }, [])

    return (
        <Form form={form} layout="vertical" onFinish={handleFinish}>

            <Row style={{ width: "100%" }}>
                <Col span={24}>
                    <Form.Item
                        label="Select Date Range"
                        name="dates"
                        rules={[{ required: true, message: 'Please select date range' }]}
                    >
                        <DatePicker.RangePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>

            <Row style={{ width: "100%" }}>
                <Col span={24}>
                    <Form.Item
                        label="Select From List"
                        name="list_id"
                        rules={[{ required: true, message: 'Please select an option from the list' }]}
                    >
                        <Select
                            placeholder="Select an option"
                            onChange={(value) => setSelectedEmail(value)}
                            showSearch
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            optionFilterProp="children"
                            allowClear
                        >
                            {dropdownList.map(item => (
                                <Select.Option key={item.email} value={item.email}>
                                    {item.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit" loading={loading.formSubmission}>
                    Submit
                </Button>
            </div>

        </Form>
    );
};

export default DownloadAnyFLSheet;
